//	+-----------------------------------------------+
//	| DfPE view objects                             |
//	+-----------------------------------------------+

/**
 * @file views.js
 * @desc RC view objects: This file contains any app-specific views.
 * @author Geoffrey Pursell
 */

/* global settings */

define('views',[
	// libraries
	"jquery", "underscore", "backbone", "hogan", "modernizr",

	// app modules
	"cardboard/baseViews", "cardboard/util", "plugins/all",

	// templates
	"text!appTemplates/ecldsReportList.html!strip"
],
function ($, _, Backbone, Hogan, Modernizr,
		  BaseViews, Util, Plugins,
		  reportListTemplate, dataBoxAdderTemplate) {

	console.log("MODULE: views");

	/**
	 * @exports views
	 * @desc RC view objects: This module contains app-specific views.
	 */
	var Views = {};

		/**
	 * For displaying the report selector on the landing page
	 * @class module:cardboard/baseViews.ReportListView
	 * @augments BaseViews.BaseView
	 * @classdesc View to display the list of reports/topics to pick from.
	 * @param {Object} options a hash of options to pass to the
	 * backbone view. {@link http://backbonejs.org/#View-constructor}
	 */
	Views.ECLDSReportListView = BaseViews.ReportListView.extend(
	/** @lends module:views.ECLDSReportListView.prototype */
	{
		// properties
		reportListTemplate: reportListTemplate,

		render: function () {
			var okToRender = BaseViews.ReportListView.prototype.render.apply(this, arguments);

			if (okToRender) {
				// render with Hogan and slam it into the DOM
				var $ul = $("#navDrawer ul.information");
				$ul.listview();
			}
		}
	});


	return Views;
});

